/**
 * Lazy-load Reviews.io rating bar on desktop only to avoid header CLS on mobile.
 */
(function () {
  const bar = document.querySelector('[data-header-utility-bar]');
  if (!bar || bar.dataset.showReviews !== 'true') {
    return;
  }

  const desktopQuery = window.matchMedia('(min-width: 769px)');

  function isBarVisible() {
    return bar.offsetParent !== null && desktopQuery.matches;
  }

  function updateHeaderMetrics() {
    const storeHeader = document.querySelector('store-header');
    if (storeHeader && typeof storeHeader.updateHeaderHeights === 'function') {
      storeHeader.updateHeaderHeights();
    } else if (typeof window.setHeaderHeight === 'function') {
      window.setHeaderHeight();
    }
  }

  function markReviewsLoaded() {
    bar.classList.add('header-utility-bar--reviews-loaded');
    updateHeaderMetrics();
  }

  function watchWidget(widget) {
    if (widget.children.length > 0) {
      markReviewsLoaded();
      return;
    }

    const observer = new MutationObserver(() => {
      if (widget.children.length > 0) {
        markReviewsLoaded();
        observer.disconnect();
      }
    });

    observer.observe(widget, { childList: true, subtree: true });
  }

  function loadReviewsWidget() {
    if (bar.dataset.reviewsLoaded === 'true' || !isBarVisible()) {
      return;
    }

    bar.dataset.reviewsLoaded = 'true';

    const widget = bar.querySelector('.reviews-io-rating-bar-widget');
    if (!widget) {
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = '//widget.reviews.io/modern-widgets/rating-bar.js';
    script.onload = () => watchWidget(widget);
    document.head.appendChild(script);
  }

  function init() {
    if (isBarVisible()) {
      loadReviewsWidget();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  desktopQuery.addEventListener('change', () => {
    if (desktopQuery.matches) {
      loadReviewsWidget();
    }
  });

  document.addEventListener('on:breakpoint-change', () => {
    if (desktopQuery.matches) {
      loadReviewsWidget();
    }
  });
})();
